import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';
// import * as AccountIcons from '../account/Icons';
// import CallVolumeReport from './CallVolumeReport';
import * as MuiCore from '@material-ui/core';
// import TableChart from '../ui/TableChart'
import moment from 'moment'
// import MailIcon from '@material-ui/icons/Mail';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';

const styles = theme => ({
    contentBox: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    rootGrid: {
        padding: theme.spacing(1),
        overflow: 'auto',
    },
    root: {
        flexGrow: theme.spacing(1),
    }, paper: {
        borderRadius: 20,
        padding: 20,
        flex:1,
        // marginRight: 10,
        // marginBottom: 10,
        textAlign: 'center',
    },
    table: {
        marginTop: 10,
    },
    tableHead: {
        background: theme.palette.primary.main,
        backgroundImage: "linear-gradient(160deg, #ff0096, #7f004b)",
        color: '#fff',
    },
    tableTitle: {
        color: '#fff'
    }, topLayout: {
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 1,
        width: '100%',
        height: '100%',
    },
    titleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    title: {
        ...theme.typography.h6,
        fontWeight: 'bold',
        //paddingLeft: 20,
        //paddingRight: 20,
    },
    box: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: '50%',
        bottom: '70%',
        marginRight: 10,
        marginBottom: 10,
        borderRadius: 20,
        padding: 0,
    },
    dropdown: {
        marginRight: 10,
        align: 'right'
    },
    biReportStyle: {
        height: 500,
        overflow: "auto"
    },
    me: {
        color: 'white',
        backgroundColor: theme.palette.primary.main
    },
    other: {
        color: 'white',
        backgroundColor: theme.palette.secondary.main
    },
    meMsg: {
        paddingLeft: '16px',
        margin: '10px',
        background: 'azure',
        borderRadius: '20px',
        paddingRight: '16px',
    },
    otherMsg: {
        display: 'flex',
        paddingLeft: '124px',
        margin: '10px',
        background: 'azure',
        borderRadius: '20px',
        paddingRight: '16px',
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
    },
    accordian:{
        marginBottom:'8px'
    },
    accordianSummary:{
        background:'white',
        color:"black"
    },
});

class WebLeads extends Component {
    constructor(props) {
        super(props);

        this.state = {
            callVolumes: {
                id:1,
                series: [{
                    name: 'Call Volume',
                    data: []
                }, {
                    name: 'Billable Minutes',
                    data: []
                }],
                categories: []
            },
        };
    }

    handleChange = (panel) => (event, panel) => {
        console.log("")
        this.setState({expanded: panel})
    }

    componentDidMount() {
        var accounts = (this.props.user.userAccountRoles || [])
            .filter(role => (role.userRoleKey === 'GLOBALADMIN'));

        if (this.props.accountId !== '') {
            this.props.queryAccount();
            this.props.queryChats();
        }
        else if (accounts.length > 0 && this.props.accountId === '') {
            this.props.setAccountId(accounts[0].accountId);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.accountId !== this.props.accountId) {
            this.props.queryAccount();
            this.props.queryChats();
        }
        
    }

    getColorByAuthor = (author) => {
        if(author ==='System'){
            return "botMsg";
        }
        else if(author ==="kswamy@call-ruby.com"){
            return "meMsg";
        }else{
            return "otherMsg";
        }
    }

    getAvatarColorByAuthor = (author) => {
        if(author ==='System'){
            return "bot";
        }
        else if(author ==="kswamy@call-ruby.com"){
            return "me";
        }else{
            return "other";
        }
    }


    toHHMMSS = (value) => {
        value = isNaN(value) ? 0: value
        var sec_num = parseInt(Math.round(value), 10); // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
    
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        if(hours === "00"){
          return minutes+':'+seconds;
        }
        return hours+':'+minutes+':'+seconds;
      }

    render() {
        const { classes } = this.props;
        var distinctAccounts=[];
        var accounts = (this.props.user.userAccountRoles || [])
                        .filter((role,index,arr) => {
                        if(role.userRoleKey === 'GLOBALADMIN' && distinctAccounts.indexOf(role.accountId) === -1){
                          distinctAccounts.push(role.accountId)
                          console.log(distinctAccounts)
                          return true;
                        }else{
                          return false;
                        }
                      });
        return (
            <div className={classes.root}>
                <Grid container spacing={2} className={classes.rootGrid}>

                    <Grid item md={12} xs={12} style={{display:'flex',justifyContent:'center',alignItems:'center',padding:"16px",flexWrap:'wrap'}}>
                    <MuiCore.FormControl className={classes.formControl}>
                          <MuiCore.InputLabel id="demo-simple-select-label">Account</MuiCore.InputLabel>
                        <MuiCore.Select className={classes.dropdown}
                         labelId="demo-simple-select-label"
                            onChange={(event) => {
                                this.props.setAccountId(event.target.value)
                                if (event.target.value !== 'n') {
                                    this.props.queryAccount();
                                }
                            }}
                            value={this.props.accountId}>

                            {accounts.map(account => (
                                <MuiCore.MenuItem key={account.accountId} value={account.accountId}>
                                    {account.accountNumber} {account.accountName}
                                </MuiCore.MenuItem>
                            ))}

                        </MuiCore.Select>
                        </MuiCore.FormControl>


                    </Grid>

                    <Grid item md={12} xs={12} >
                        <Paper className={classes.paper}>
                            <div className={classes.titleBar}>
                                <div style={{ display: 'flex',alignItems:'center',padding:'8px' }}>
                                <EmojiPeopleIcon />
                                    <div className={classes.title}>
                                        Web Leads
                                        </div>
                                </div>
                                <MuiCore.FormControl className={classes.formControl}>
                                <MuiCore.InputLabel id="demo-chat-select-label">Lead</MuiCore.InputLabel>
                                <MuiCore.Select className={classes.dropdown}
                                    labelId="demo-chat-select-label"
                                    // onChange={(event) => {
                                    //     this.setState({expanded:event.target.value})
                                    // }}
                                    value={this.state.expanded ? this.state.expanded.title : ""}>
                                    {this.props.chats && this.props.chats.map(item => (
                                        <MuiCore.MenuItem key={item.title} value={item.title} onClick={() => this.setState({expanded:item})}>
                                            {item.title}
                                        </MuiCore.MenuItem>
                                    ))}

                                </MuiCore.Select>
                                </MuiCore.FormControl>
                                    </div>

                                    {this.state.expanded && this.state.expanded.title && 
                                    <MuiCore.Grid container>
                                        <MuiCore.Grid item xs={8}>
                                        <MuiCore.List style={{ overflowY: 'scroll', background: 'white', padding: '32px', lineBreak: 'auto' }}>
                                            {this.state.expanded.messages && this.state.expanded.messages.slice().sort((a,b) => a.chatMessageId - b.chatMessageId).map((text) => (
                                                <MuiCore.ListItem key={text.chatMessageId} className={classes[this.getColorByAuthor(text.chatParticipantId)]}>
                                                    <MuiCore.ListItemIcon> <MuiCore.Avatar className={classes[this.getAvatarColorByAuthor(text.chatParticipantId)]} >{text.chatParticipantId.length >= 2 && text.chatParticipantId.substr(0, 2).toUpperCase()}</MuiCore.Avatar></MuiCore.ListItemIcon>
                                                    <MuiCore.ListItemText primary={text.textContents} secondary={moment(text.added, "YYYYMMDDHHmmss").local().format("YYYY-MM-DD HH:mm:ss z")} />

                                                </MuiCore.ListItem>
                                            ))}
                                        </MuiCore.List>
                                        </MuiCore.Grid>
                                        <MuiCore.Grid item xs={4}>

                                                {this.state.expanded.webleadJson && this.state.expanded.webleadJson.twilio && this.state.expanded.webleadJson.twilio.collected_data && Object.keys(this.state.expanded.webleadJson.twilio.collected_data).map((taskType) => (
                                                    <React.Fragment>
                                                        
                                                        <MuiCore.TableContainer component={MuiCore.Paper}>
                                                        <MuiCore.Table size="small" aria-label="simple dense table">
                                                            <MuiCore.TableHead>
                                                                <MuiCore.TableRow>
                                                                    <MuiCore.TableCell colSpan={2} align="center">Insights</MuiCore.TableCell>
                                                                </MuiCore.TableRow>
                                                            </MuiCore.TableHead>
                                                            <MuiCore.TableBody>
                                                                {Object.keys(this.state.expanded.webleadJson.twilio.collected_data[taskType].answers).map((info) => (
                                                                <MuiCore.TableRow>
                                                                
                                                                <MuiCore.TableCell>
                                                                   {info.replaceAll("_"," ")}
                                                                </MuiCore.TableCell>
                                                                <MuiCore.TableCell>
                                                                    {this.state.expanded.webleadJson.twilio.collected_data[taskType].answers[info].answer}
                                                                </MuiCore.TableCell>
                                                                
                                                                </MuiCore.TableRow>
                                                                ))}
                                                            </MuiCore.TableBody>
                                                        </MuiCore.Table>
                                                        </MuiCore.TableContainer>
                                                       
                                                        {/* {Object.keys(this.state.expanded.webleadJson.twilio.collected_data[taskType].answers).map((info) => (
                                                            <React.Fragment>

                                                                 <MuiCore.Typography variant="subtitle2">{info.replaceAll("_"," ")}</MuiCore.Typography>

                                                            <MuiCore.Typography variant="caption">{this.state.expanded.webleadJson.twilio.collected_data[taskType].answers[info].answer}</MuiCore.Typography>
                                                        </React.Fragment>
                                                        ))} */}
                                                       
                                                    </React.Fragment>
                                                ))}
                                        </MuiCore.Grid>
                                    </MuiCore.Grid>
                                    }

                              
                            
                                {/* {this.props.chats && this.props.chats.map(item => (
                                    <MuiCore.Accordion key={item.title} className={classes.accordian}>
                                    <MuiCore.AccordionSummary  expanded={this.state.expanded === item.title} onChange={this.handleChange(item.title)}
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        className={classes.accordianSummary}
                                        id={"panel1a-header-"+item.title}
                                    >
                                        <MuiCore.Typography className={classes.heading} style={{marginRight:'8px'}}>{item.title.replace("_SUPPORT", "")}</MuiCore.Typography>
                                  
                                        <MuiCore.Badge badgeContent={item.messages.length} color="primary">
                                        <MailIcon />
                                        </MuiCore.Badge>
                                    </MuiCore.AccordionSummary>
                                    <MuiCore.AccordionDetails>

                                    <MuiCore.Grid container>
                                        <MuiCore.Grid item xs={8}>
                                        <MuiCore.List style={{ overflowY: 'scroll', maxHeight: '30vh', background: 'white', padding: '32px', lineBreak: 'auto' }}>
                                            {item.messages && item.messages.slice().sort((a,b) => a.chatMessageId - b.chatMessageId).map((text) => (
                                                <MuiCore.ListItem key={text.chatMessageId} className={classes[this.getColorByAuthor(text.chatParticipantId)]}>
                                                    <MuiCore.ListItemIcon> <MuiCore.Avatar className={classes[this.getAvatarColorByAuthor(text.chatParticipantId)]} >{text.chatParticipantId.length >= 2 && text.chatParticipantId.substr(0, 2).toUpperCase()}</MuiCore.Avatar></MuiCore.ListItemIcon>
                                                    <MuiCore.ListItemText primary={text.textContents} secondary={moment(text.added, "YYYYMMDDHHmmss").local().format("YYYY-MM-DD HH:mm:ss z")} />

                                                </MuiCore.ListItem>
                                            ))}
                                        </MuiCore.List>
                                        </MuiCore.Grid>
                                        <MuiCore.Grid item xs={4}>
                                                <MuiCore.Typography variant="subtitle1">
                                                    Insights
                                                </MuiCore.Typography>


                                                {item.webleadJson && item.webleadJson.twilio && item.webleadJson.twilio.collected_data && Object.keys(item.webleadJson.twilio.collected_data).map((taskType) => (
                                                    <React.Fragment>

                                                        {Object.keys(item.webleadJson.twilio.collected_data[taskType].answers).map((info) => (
                                                            <React.Fragment>

                                                                 <MuiCore.Typography variant="subtitle2">{info.replaceAll("_"," ")}</MuiCore.Typography>

                                                            <MuiCore.Typography variant="caption">{item.webleadJson.twilio.collected_data[taskType].answers[info].answer}</MuiCore.Typography>
                                                        </React.Fragment>
                                                        ))}
                                                       
                                                    </React.Fragment>
                                                ))}

                                        </MuiCore.Grid>
                                    </MuiCore.Grid>
                                    </MuiCore.AccordionDetails>
                                </MuiCore.Accordion>
                                ))} */}
                               
                            
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        user: coreSelectors.getUser(state),
        accountId: accountSelectors.getAccountId(state),
        account: accountSelectors.getAccount(state),
        chats: accountSelectors.getWebLeads(state),
    });
};

const mapDispatchToProps = {
    setAccountId: accountActions.setAccountId,
    queryAccount: accountActions.queryAccount,
    queryChats: accountActions.queryChats,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(WebLeads));
